let cachedOutfitNames = null;
let loadingPromise = null;

export async function getOutfitNames() {
    if (cachedOutfitNames) return cachedOutfitNames;
    if (loadingPromise) return loadingPromise;

    loadingPromise = (async () => {
        const file = `/outfits.xml`;

        const response = await fetch(file);
        const xmlText = await response.text();

        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlText, "text/xml");
        const outfits = xmlDoc.getElementsByTagName("outfit");

        const outfitNames = {};

        for (let i = 0; i < outfits.length; i++) {
            const looktype = outfits[i].getAttribute("looktype");
            const name = outfits[i].getAttribute("name");
            outfitNames[looktype] = name;
        }

        cachedOutfitNames = outfitNames;
        return cachedOutfitNames;
    })();

    return loadingPromise;
}
